/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';

interface SelfServeMigrationModalIdToMultiIdUnderstandValidationArgs {
  onContinue: () => unknown;
  onCancel: () => unknown;
}

export default class SelfServeMigrationModalIdToMultiIdUnderstandValidation extends Component<SelfServeMigrationModalIdToMultiIdUnderstandValidationArgs> {
  readonly exampleData = [
    {
      label: 'We verify emails are valid',
      caption: 'Example of valid and invalid email addresses',
      data: [
        /* eslint-disable spellcheck/spell-checker */
        { name: 'Ami Jones', email: 'ami@gmail.com', validity: 'valid', state: 'success', icon: 'check-circle' },
        {
          name: 'Tom White',
          email: 'k@.dk',
          validity: 'invalid',
          state: 'error',
          icon: 'does-not-send',
          duotoneIcon: true,
        },
      ],
    },
    {
      label: 'And unique',
      caption: 'Example of duplicate email addresses',
      data: [
        /* eslint-disable spellcheck/spell-checker */
        { name: 'Kate S', email: 'kate@yahoo.com', validity: 'unique', state: 'success', icon: 'check-circle' },
        /* eslint-disable spellcheck/spell-checker */
        {
          name: 'Kate Smith',
          email: 'kate@yahoo.com',
          validity: 'duplicate',
          state: 'error',
          icon: 'does-not-send',
          duotoneIcon: true,
        },
      ],
    },
  ];

  readonly accordionData = [
    {
      label: 'How is new data affected?',
      content:
        "We'll hold onto requests to add new people and events, and process them when the validation process is complete. Everything else will work as usual.",
    },
    {
      label: 'Are you using reporting webhooks?',
      content: htmlSafe(
        'When email is enabled as an identifier, <code>customer_id</code> will be null for profiles without an <code>id</code>. You can update your endpoints to use the identifiers object instead. <a href="https://customer.io/docs/webhooks/#the-identifiers-object" rel="noreferrer noopener" target="_blank">Learn more</a>.',
      ),
    },
  ];
}
